export default __webpack_public_path__ + "static/media/img_net_connect-colorBkg.e6db6fcb.png";